<template>
	<v-col class="ma-0 pa-0 pl-5 pr-5 pb-5 mb-5" cols="12" style="border-bottom:1px solid #4C4C4C;">
		<v-row class="ma-0 pa-0 mt-2 mb-2" align="center" justify="space-between">
			<v-row class="ma-0 pa-0" align="center">
				<v-col class="ma-0 pa-0 ml-5" cols="auto" align="left" style="font-weight:bold;">
					{{ store.customerName }}
				</v-col>
			</v-row>
		</v-row>
		<template v-if="cardLoading">
			<v-row class="ma-0 pa-0" align="center">
				<v-col class="ma-0 pa-0" cols="3">
					<v-skeleton-loader :boilerplate="false" elevation="0" dark type="image" width="100%"
						height="11rem"></v-skeleton-loader>
				</v-col>
				<v-col class="ma-0 pa-0 pl-4" cols="9">
					<v-skeleton-loader :boilerplate="false" elevation="0" dark type="image" width="100%"
						height="11rem"></v-skeleton-loader>
				</v-col>
			</v-row>
		</template>
		<template v-else>
			<v-row class="ma-0 pa-0 pl-5" align="start">
				<v-col class="ma-0 pa-0" v-if="store.numberOfUas > 0" :class="{ 'pr-4': store.storeCameras.length > 0 }"
					:cols="getColsNum('analysis')">
					<v-col id="data_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;"
						@click="$emit('analyze-click', store)">
						<v-col class="ma-0 pa-3 pl-5 pr-5" cols="12">
							<v-col class="ma-0 pa-0 mb-1" cols="12">
								<v-row class="ma-0 pa-0" align="center" justify="space-between" style="font-weight:bold;">
									<v-col id="data_sub_title" class="ma-0 pa-0" cols="auto">
										{{ tsc('last30DaysVisitors') }}
									</v-col>
									<v-col class="ma-0 pa-0" cols="auto">
										<v-row class="ma-0 pa-0" align="center" style="color: #008DD0;font-size:0.8rem;">
											{{ tsc('viewAnalyze') }}
											<v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 ml-2"
												src="@/assets/images/blue_right_icon.png"></v-img>
										</v-row>
									</v-col>
								</v-row>
							</v-col>
							<v-col id="data_people_box" class="ma-0 pa-0" cols="12">
								<v-row class="ma-0 pa-0" align="center">
									<v-col class="ma-0 pa-1" cols="6">
										<v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12" align="left">
											{{ tsc('all') }}
										</v-col>
										<v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12" align="left">
											{{ totalCount.total + tsc('peopleCount') }}
										</v-col>
									</v-col>
									<v-col class="ma-0 pa-1" cols="6">
										<v-col id="data_sub_title" class="ma-0 pa-0 pl-2" cols="12" align="left">
											{{ tsc('faceRecognition') }}
										</v-col>
										<v-col id="data_count" class="ma-0 pa-0 pl-2" cols="12" align="left">
											{{ totalCount.known + tsc('peopleCount') }}
										</v-col>
									</v-col>
								</v-row>
							</v-col>
						</v-col>
						<v-col class="ma-0 pa-0 pr-2 pb-3" cols="12" style="position: relative;">
							<BarChart :chart-data="visitorData" :options="chartOptions" :height="75"></BarChart>
							<v-col id="no_data" class="ma-0 pa-0" cols="12"
								v-if="hourlyFetched && visitorData.datasets[0].data.length == 0">
								{{ t('noData') }}
							</v-col>
						</v-col>
					</v-col>
				</v-col>
				<v-col class="ma-0 pa-0" v-if="store.storeCameras.length > 0 && authorities.GET_RECORDING_SUB_BRANCH"
					:cols="getColsNum('camera')">
					<v-col id="data_box" class="ma-0 pa-0" cols="12" style="cursor: pointer;" @click="$emit('cctv-click', store)">
						<v-col class="ma-0 pa-3 pl-5 pr-5 pb-4" cols="12">
							<v-row class="ma-0 pa-0 mb-1" align="center" justify="space-between" style="font-weight:bold;">
								<v-col id="data_sub_title" class="ma-0 pa-0" cols="auto">
									{{ tsc('camera') }}
								</v-col>
								<v-col class="ma-0 pa-0" cols="auto">
									<v-row class="ma-0 pa-0" align="center" style="color: #008DD0;font-size:0.8rem;">
										{{ tsc('viewCameras') }}
										<v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 ml-2"
											src="@/assets/images/blue_right_icon.png"></v-img>
									</v-row>
								</v-col>
							</v-row>
							<v-row class="ma-0 pa-0" style="min-width: 0;">
								<v-row class="ma-0 pa-0" align="center" style="min-width: 0; width: 100%;">
									<v-col v-for="(camera, idx) in displayCameras" :key="idx" class="ma-0 pa-0 pr-1 pb-1" cols="3"
										style="min-width: 0;">
										<!-- 오프라인 카메라도 출력 (GroupStoreListItem 과 동일 스펙) -->
										<div v-if="camera.streamAble == false" class="ma-0 pa-0"
											style="height: 8rem; line-height:8rem; text-align:center; background:grey;">
											<p style="white-space:pre-wrap;font-size:0.85rem;">{{ t('offline') }}</p>
										</div>
										<div v-else-if="camera.thumbnail != undefined">
											<v-img height="8rem" max-width="100%" class="ma-0 pa-0" style="background:grey;"
												:src="camera.thumbnail"
												@error="thumbnailError('no_data_box_' + camera.unisCustomerCd + '_' + idx)">
												<v-col :id="'no_data_box_' + camera.unisCustomerCd + '_' + idx"
													class="ma-0 pa-0 no_data_box_style">
													{{ t('thumbnailError') }}
												</v-col>
											</v-img>
										</div>
										<div v-else class="ma-0 pa-0"
											style="height: 8rem; line-height:8rem; text-align:center; background:grey;">
											<p style="white-space:pre-wrap;font-size:0.85rem;">{{ t('notStreaming') }}</p>
										</div>
									</v-col>
								</v-row>
							</v-row>
						</v-col>
					</v-col>
				</v-col>
			</v-row>
		</template>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import BarChart from '@/components/barChart.js';
import * as Option from '@/components/chartOptions';

export default {
	components: { BarChart },
	mixins: [mixin.common],
	props: {
		store: { type: Object, required: true },
		authorities: { type: Object, default: () => ({}) },
	},
	data: () => ({
		isVisible: false,
		hourlyFetched: false,
		visibilityDelayTimer: null,
		observer: null,
		visitorData: {
			labels: ['07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00',
				'15:00', '16:00', '17:00', '20:00', '21:00', '22:00', '23:00', '24:00'],
			datasets: [
				{ backgroundColor: '#CFCF39', data: [], borderWidth: 0, borderColor: 'transparent', barThickness: 'flex', hoverOffset: 0 },
				{ backgroundColor: '#9A9A9A', data: [], borderWidth: 0, borderColor: 'transparent', barThickness: 'flex', hoverOffset: 0 },
			],
		},
		chartOptions: null,
		totalCount: { total: 0, known: 0 },
	}),
	computed: {
		displayCameras() {
			return (this.store.storeCameras || []).slice(0, 4);
		},
		cardLoading() {
			// 첫 진입 직후 차트 fetch 전이면 skeleton 노출. 카메라 그리드는 fetch 무관하므로
			// 차트 영역 fetch 완료 또는 numberOfUas == 0(차트 미노출) 이면 즉시 표시.
			if (this.store.numberOfUas > 0) return !this.hourlyFetched;
			return false;
		},
	},
	mounted() {
		this.chartOptions = JSON.parse(JSON.stringify(Option.searchChartOption));
		this.setupObserver();
	},
	beforeDestroy() {
		if (this.observer) this.observer.disconnect();
		if (this.visibilityDelayTimer) clearTimeout(this.visibilityDelayTimer);
	},
	methods: {
		setupObserver() {
			this.observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting && !this.isVisible) {
						this.isVisible = true;
						this.onVisible();
					}
				});
			}, { rootMargin: '100px 0px' });
			this.observer.observe(this.$el);
		},
		onVisible() {
			if (this.visibilityDelayTimer) clearTimeout(this.visibilityDelayTimer);
			this.visibilityDelayTimer = setTimeout(() => {
				this.fetch24h();
				this.fetch30d();
			}, 300);
		},
		getColsNum(type) {
			const uasCount = this.store.numberOfUas;
			const camCount = this.store.storeCameras.length;
			if (type === 'analysis') {
				if (camCount < 1) return 12;
				return 3;
			}
			if (type === 'camera') {
				if (uasCount < 1) return 12;
				return 9;
			}
			return 12;
		},
		zeroPadding(n) {
			return ('00' + n).slice(-2);
		},
		getDateFormatFromHour(d) {
			return d.getFullYear() + this.zeroPadding(d.getMonth() + 1) + this.zeroPadding(d.getDate()) + '07';
		},
		getDateFormatToHour(d) {
			return d.getFullYear() + this.zeroPadding(d.getMonth() + 1) + this.zeroPadding(d.getDate()) + '24';
		},
		make18HourList(date) {
			const result = [];
			const month = this.zeroPadding(date.getMonth() + 1);
			const day = this.zeroPadding(date.getDate());
			const startDate = new Date(`${date.getFullYear()}-${month}-${day}T07:00:00`);
			for (let i = 0; i < 18; i++) {
				if (i === 0) {
					result.push(`${date.getFullYear()}${month}${day}0700`);
				} else {
					const tmp = new Date(startDate.setHours(startDate.getHours() + 1));
					const mm = this.zeroPadding(tmp.getMonth() + 1);
					const dd = this.zeroPadding(tmp.getDate());
					const hh = this.zeroPadding(tmp.getHours());
					result.push(`${tmp.getFullYear()}${mm}${dd}${hh}00`);
				}
			}
			return result;
		},
		fetch24h() {
			if (this.store.numberOfUas <= 0) {
				this.hourlyFetched = true;
				return;
			}
			const currStart = new Date();
			const from = this.getDateFormatFromHour(currStart);
			const hourList = this.make18HourList(currStart);
			const to = this.getDateFormatToHour(new Date());
			this.networkController.getAnalyticsVisitors({}, 'hour', from, to, this.store.unisCustomerCd)
				.then((res) => {
					if (res.data && res.data.length !== 0) {
						const known = [];
						const unknown = [];
						hourList.forEach((hour) => {
							const idx = res.data.findIndex((el) => el.start == hour);
							if (idx !== -1) {
								known.push(res.data[idx].Data.known);
								unknown.push(res.data[idx].Data.unknown);
							} else {
								known.push(0);
								unknown.push(0);
							}
						});
						this.visitorData.datasets[0].data = known;
						this.visitorData.datasets[1].data = unknown;
						const max1 = Math.max(...known);
						const max2 = Math.max(...unknown);
						const visitorMax = this.getMaxValue(max1 + max2);
						this.chartOptions.scales.yAxes[0].ticks.max = visitorMax;
						this.chartOptions.scales.yAxes[0].ticks.stepSize = visitorMax / 2;
					}
					this.hourlyFetched = true;
				})
				.catch(() => {
					this.hourlyFetched = true;
				});
		},
		fetch30d() {
			if (this.store.numberOfUas <= 0) return;
			const currStart = new Date();
			currStart.setDate(currStart.getDate() - 30);
			const from = this.getDateFormatFromHour(currStart);
			const to = this.getDateFormatToHour(new Date());
			this.networkController.getAnalyticsVisitors({}, 'day', from, to, this.store.unisCustomerCd)
				.then((res) => {
					if (res.data && res.data.length !== 0) {
						let total = 0;
						let known = 0;
						res.data.forEach((d) => {
							total += d.Data.total;
							known += d.Data.known;
						});
						this.totalCount.total = total;
						this.totalCount.known = known;
					}
				})
				.catch(() => { });
		},
		thumbnailError(idName) {
			const el = document.getElementById(idName);
			if (el) el.style.display = 'block';
		},
	},
};
</script>

<style lang="scss" scoped>
#data_box {
	background-color: #34363C;
	border-radius: 4px;
}

#data_people_box {
	background-color: #5C5D62;
	border-radius: 4px;
}

#data_sub_title {
	color: #CECED0;
	font-size: 0.8rem;
}

#data_count {
	font-weight: bold;
}

.no_data_box_style {
	height: 8rem;
	line-height: 8rem;
	text-align: center;
	background: grey;
	color: white;
	display: none;
}

#no_data {
	font-size: 0.8rem;
	position: absolute;
	z-index: 2;
	top: 30%;
	left: 50%;
	transform: translate(-50%, -35%);
}
</style>
